import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import city from './module/city'
import cinema from './module/cinema'

export default new Vuex.Store({
    modules: {
        city,
        cinema
    },
})
